module.exports = "<svg id=\"39d96f88-041b-4739-965b-363d39f1818a\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 49.97 28.24\"><defs></defs><title>RightArrow</title><path class=\"165402b6-c395-4f09-99d8-809c59e33f51\" d=\"M49.93,25.14a2.46,2.46,0,0,0-.36-1l-10-12.48a1.68,1.68,0,0,0-2.34-.26A1.73,1.73,0,0,0,37,13.7l7.83,9.78H1.66a1.66,1.66,0,1,0,0,3.33H44.8L37,36.58a1.77,1.77,0,0,0,.26,2.34,1.67,1.67,0,0,0,2.34-.26l10-12.48a1.52,1.52,0,0,0,.36-1Z\" transform=\"translate(0 -11.04)\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/RightArrow.svg
// module id = 522
// module chunks = 1